import { useQuery } from '@tanstack/react-query';
import { workflowApi } from '../services/api';
import { Workflow } from '../types/workflow';

export function useWorkflow(workflowId: string | null) {
  return useQuery<Workflow>({
    queryKey: ['workflow', workflowId],
    queryFn: () => workflowApi.getWorkflow(workflowId!),
    enabled: !!workflowId,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}